import { component } from 'knockout-decorators'

import { AppNavigation, Language } from '~/utils'
import { authState } from '../utils/state'

import type { SignInOptions } from '../utils/options'

import source from './logged-in.html?raw'
import { signOut } from '../utils/sign-out'

@component('logged-in-form', source)
export class LoggedInForm {
  constructor(private options: SignInOptions) {}
  private Locale = Language.getInstance()

  public i18n(key: string): string {
    return this.Locale.translations[key]
  }

  private state = authState

  public async logout(): Promise<void> {
    this.state.isLoading = true
    await signOut(this.options.useJwt, () => {
      this.state.isLoading = false
    })
  }

  private redirectToTickets() {
    AppNavigation.tickets()
  }
}
